<template>
  <div>
    <el-dialog :visible.sync="visible" width="1000px" title="临时数据">
      <div style="margin-bottom:20px;">
        <el-button @click="createVisible = true" type="primary" size="small"
          >添加临时数据</el-button
        >
        <el-select v-model="searchShareType" @change="typeChanged" size="small" class="search-type">
            <el-option
              :key="''"
              label="全部类型"
              :value="''"></el-option>
            <el-option
              v-for="item in shareTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
      </div>
      <el-table :data="tempData" border>
        <el-table-column label="周期ID" prop="cycleId"></el-table-column>
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="用户账号" prop="userAccount"></el-table-column>
        <el-table-column label="是否是真实用户数据">
          <template slot-scope="scope">
            <span v-if="scope.row.realData">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            {{ scope.row.shareType | shareType }}
          </template>
        </el-table-column>
        <el-table-column label="是否有效">
          <template slot-scope="scope">
            <span v-if="scope.row.valid">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="数据量" prop="dataNum"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="small"
              circle
              icon="el-icon-delete"
              @click="handleRemove(scope.row.cycleId, scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pager.size"
        :page="pager.page"
        :total="tempDataTotal"
        @pageChanged="handlePageChanged"
      >
      </pagination>
    </el-dialog>
    <el-dialog
      :visible.sync="createVisible"
      @closed="createClosed"
      width="600"
      title="添加临时数据"
    >
      <el-form :model="form" ref="form" :rules="rules" label-width="100px">
        <el-form-item prop="userId" label="用户ID">
          <el-input v-model="form.userId"></el-input>
        </el-form-item>
        <el-form-item prop="userAccount" label="用户账号" label-width="100px">
          <el-input v-model="form.userAccount"></el-input>
        </el-form-item>
        <el-form-item prop="shareType" label="类型" label-width="100px">
          <el-select v-model="form.shareType">
            <el-option
              v-for="item in shareTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="dataNum" label="数据量" label-width="100px">
          <el-input v-model="form.dataNum"></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-wrap">
        <el-button type="success" @click="sub()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import "../store.js";
import Pagination from "../../../components/pagination";
import { mapState, mapActions } from "vuex";
import { SHARE_TYPE } from "../constant.js";
export default {
  name: "contractFeeTempData",
  data() {
    return {
      visible: false,
      createVisible: false,
      cycleId: "",
      searchShareType: "",
      pager: {
        page: 1,
        size: 10
      },
      form: {
        dataNum: "",
        shareType: 1,
        userAccount: "",
        userId: ""
      },
      rules: {
        dataNum: [
          {
            required: true,
            message: "请输入数据量"
          }
        ],
        shareType: [
          {
            required: true,
            message: "请选择类型"
          }
        ],
        userId: [
          {
            required: true,
            message: "请输入用户ID"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState("contractFee", ["tempData", "tempDataTotal"]),
    shareTypes() {
      return [
        {
          value: 1,
          label: SHARE_TYPE[1]
        },
        {
          value: 2,
          label: SHARE_TYPE[2]
        },
        {
          value: 3,
          label: SHARE_TYPE[3]
        }
      ];
    }
  },
  methods: {
    ...mapActions("contractFee", [
      "getTempData",
      "addTempData",
      "removeTempData"
    ]),
    getData() {
      let q = {
        cycleId: this.cycleId,
        ...this.pager
      }
      if(this.searchShareType != "") q.shareType = this.searchShareType;
      this.getTempData(q);
    },
    showData(cycleId) {
      this.cycleId = cycleId;
      this.getData(this.pager);
      this.visible = true;
    },
    handlePageChanged(val) {
      this.pager.page = val.page;
      this.pager.size = val.size;
      this.getData();
    },
    sub() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let data = {
            cycleId: this.cycleId,
            ...this.form
          };
          this.addTempData(data).then(() => {
            this.$message({
              message: "添加成功！",
              type: "success"
            });
            this.createVisible = false;
            this.getData(this.pager);
          });
        }
      });
    },
    handleRemove(cycleId, id) {
      this.$confirm("确定删除这条数据吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          this.removeTempData({
            cycleId,
            id
          }).then(() => {
            this.$message({
              message: "删除成功！",
              type: "success"
            });
            this.getData(this.pager);
          });
        })
        .catch(() => {});
    },
    createClosed() {
      this.$refs["form"].resetFields();
    },
    typeChanged(v) {
      this.pager.page = 1;
      this.getData();
    }
  },
  filters: {
    shareType(val) {
      return SHARE_TYPE[parseInt(val)];
    }
  },
  components: {
    Pagination
  }
};
</script>
<style lang="less" scoped>
.btn-wrap {
  text-align: center;
}
.search-type {
  margin-left: 30px;
}
</style>
